import {
  fetchLanesStart,
  fetchLanesSuccess,
  fetchLanesFailure,
  fetchLaneGpsDataStart,
  fetchLaneGpsDataSuccess,
  fetchLaneGpsDataFailure,
  submitLaneDataStart,
  submitLaneDataSuccess,
  submitLaneDataFailure,
} from './lane.slice';

import { getLanesForDrive, getLaneGpsData, submitLaneData } from '../api/lane.api';

// Every lane endpoint now responds with the same envelope:
//   { status, data: { driveStartTime, lanes: [...] } }
// (the GPS endpoint additionally nests a `driveId` alongside driveStartTime/lanes)
const unwrapLaneResponse = (response) => {
  const body = response.data?.data || {};
  return {
    lanes: Array.isArray(body.lanes) ? body.lanes : [],
    driveStartTime: body.driveStartTime || null,
  };
};

// Fetch lanes for a drive
const fetchLanes = (driveId) => async (dispatch) => {
  dispatch(fetchLanesStart());
  try {
    const response = await getLanesForDrive(driveId);
    dispatch(fetchLanesSuccess(unwrapLaneResponse(response)));
    // also fetch the lane gps details endpoint and merge/adapt into state
    dispatch(fetchLaneGpsData(driveId));
  } catch (error) {
    dispatch(fetchLanesFailure(error.message || 'Failed to fetch lanes'));
  }
};

// Fetch GPS data for lanes
const fetchLaneGpsData = (driveId) => async (dispatch) => {
  dispatch(fetchLaneGpsDataStart());
  try {
    const response = await getLaneGpsData(driveId);
    dispatch(fetchLaneGpsDataSuccess(unwrapLaneResponse(response)));
  } catch (error) {
    dispatch(fetchLaneGpsDataFailure(error.message || 'Failed to fetch lane GPS data'));
  }
};

// Submit lane data
const submitLaneDataAction = (data) => async (dispatch) => {
  dispatch(submitLaneDataStart());
  try {
    const response = await submitLaneData(data);
    dispatch(submitLaneDataSuccess(unwrapLaneResponse(response)));
  } catch (error) {
    dispatch(submitLaneDataFailure(error.message || 'Failed to submit data'));
  }
};

export { fetchLanes, fetchLaneGpsData, submitLaneDataAction };
